import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { InputSecret, Loading, FormError } from '../../components/common';
import { useForm, useNav, useFormErrors } from '../../components/hooks';
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APPCONFIG } from '../../app.config';
import { VALIDATION_MESSAGE } from '../../consts/validationMessage';
import encrypt from '../../utils/encrypt';
import { onRequestError, standardRequest } from '../../utils/requests'
import HeaderBasic from '../../components/layout/HeaderBasic';
import { validatePassword } from '../../utils/validator';

const ChangePasswordView = () => {
    const params = useParams()
    const navigate = useNav()

    const [formValues, formHandle] = useForm({ password: '', repeatPassword: '' })
    const [loading, setLoading] = useState(false)
    const [token, setToken] = useState(null)

    useEffect(() => {
        setLoading(true)

        standardRequest(REQUEST_METHOD.GET, `${APPCONFIG.SITE.WEBAPI}api/verificacion/token/${params.token}`)
        .then(data => setToken(data.token))
        .catch(e => {
            onRequestError(e)
            setToken(null)
        })
        .finally(() => setLoading(false))
    }, [])

    const getErrors = () => {
        const errors = {}

        if (formValues.password === '') errors.password = VALIDATION_MESSAGE.REQUIRED
        if (formValues.repeatPassword === '') errors.repeatPassword = VALIDATION_MESSAGE.REQUIRED
        else if (formValues.password !== formValues.repeatPassword) errors.repeatPassword = 'Las contraseñas no coinciden'

        return errors
    }

    const getFormatErrors = () => {
        const errors = {}

        if (formValues.password !== '') {
            const validation = validatePassword(formValues.password)
            if (!validation.success) errors.password = validation.message
        }

        return errors
    }

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

    const onAccept = () => {
        if (!validate()) return

        standardRequest(
            REQUEST_METHOD.POST,
            `${APPCONFIG.SITE.WEBAPI}api/usuario/recover-password`,
            { token, password: encrypt(formValues.password) },
            { useAuth: false, },
        ).then(data => {
            setToken(null)
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, 'La contraseña fue cambiada correctamente', () => {
                navigate({ to: '/login', replace: true, })
            })
        }).catch(onRequestError)
    }

    return (
        <div>
            <HeaderBasic showMenu={false} />
            <div className='bg-img'>
            
                <Loading visible={loading}></Loading>
                    
                <div className="login-container">
                    <section className='lg-c'>

                        <div>
                            <InputSecret
                                title="Contraseña"
                                name="password"
                                type="password"
                                placeholder=""
                                autoComplete="new-password"
                                value={ formValues.password }
                                onChange={ formHandle }
                                disabled={loading || token === null}
                                required
                                invalid={!!errorOf('password')}
                            />
                            <FormError message={errorOf('password')} />
                        </div>
                        <div>
                            <InputSecret
                                title="Repetir contraseña"
                                name="repeatPassword"
                                type="password"
                                placeholder=""
                                autoComplete="new-password"
                                value={ formValues.repeatPassword }
                                onChange={ formHandle }
                                disabled={loading || token === null}
                                required
                                invalid={!!errorOf('repeatPassword')}
                            />
                            <FormError message={errorOf('repeatPassword')} />
                        </div>
                        <div className="mb-3">
                            <button className="btn btn-main" onClick={onAccept} disabled={loading || token === null}>
                                Cambiar contraseña
                            </button>
                        </div>

                        <a href='#' className="login-link" onClick={() => navigate({ to: '/login' })}>Volver</a>
                    </section>
                </div>

            </div>
        </div>
    )
}

export default ChangePasswordView